export default "__VITE_ASSET__ChdaJYUb__"